import { configureStore } from "@reduxjs/toolkit";
import lessonsReducer from "./lessonsSlice";
import particlesReducer from "./particlesReducerSlice";
import packagesReducer from "./packageSlice";
import clipboardReducer from "./clipboardSlice";

const store = configureStore({
  reducer: {
    lessons: lessonsReducer,
    particles: particlesReducer,
    packages: packagesReducer,
    clipboard: clipboardReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
